import { atom, useRecoilState } from "recoil";

const DEFAULT_STATE = {
  original: {
    text: '',
    json: {}
  },
  edit: {
    text: '',
    json: {}
  }
};

const atcPlanState = atom({
  key: 'atcPlanState',
  default: DEFAULT_STATE
});

export const useATCPlan = () => {
  const [atcPlan, setAtcPlan] = useRecoilState(atcPlanState);

  const changeATCPlan = data => {
    let newState;
    if (atcPlan.original.text === '') {
      newState = {
        original: {...data},
        edit: {...data}
      };
    } else {
      changeATCPlanEdit(data);
      return;
    }

    setAtcPlan(newState);
  }

  const changeATCPlanOrg = data => {
    const newState = {...atcPlan, original: data};
    setAtcPlan(newState);
  }

  const changeATCPlanEdit = data => {
    const newState = {...atcPlan, edit: data};
    setAtcPlan(newState);
  };

  const changeATCPlanEditJson = data => {
    const newState ={...atcPlan, edit: {...atcPlan.edit, json: data}}
    setAtcPlan(newState);
  }

  const clearATCPlan = () => {
    setAtcPlan(DEFAULT_STATE)
  };

  return {
    atcPlan,
    changeATCPlan,
    changeATCPlanOrg,
    changeATCPlanEdit,
    changeATCPlanEditJson,
    clearATCPlan
  }
}